import { render, staticRenderFns } from "./NbdhyLoadingView.vue?vue&type=template&id=2f647d95&scoped=true&"
import script from "./NbdhyLoadingView.vue?vue&type=script&lang=js&"
export * from "./NbdhyLoadingView.vue?vue&type=script&lang=js&"
import style0 from "./NbdhyLoadingView.vue?vue&type=style&index=0&id=2f647d95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f647d95",
  null
  
)

export default component.exports